function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 7c0 .97.89 1.75 2 1.75h8V28H0V0h14v7zm6 6.125c0-.479-.438-.875-1-.875H5c-.547 0-1 .396-1 .875S4.453 14 5 14h14c.563 0 1-.396 1-.875zM16 0l8 7h-8V0zm3 19.25c.563 0 1-.396 1-.875s-.438-.875-1-.875H5c-.547 0-1 .396-1 .875s.453.875 1 .875h14zm0 5.25c.563 0 1-.396 1-.875s-.438-.875-1-.875H5c-.547 0-1 .396-1 .875s.453.875 1 .875h14z",
  fill: "currentColor"
});

var SvgFileDocIcon = function SvgFileDocIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 28",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgFileDocIcon;